import 'mmenu-js'
import 'mmenu-js/dist/mmenu.css'

const MenuUsa = function () {

  let elements
  function init() {

    elements = {
      nav: {
        menu: document.getElementById('menu-mobile'),
      }
    }

    if (elements.nav.menu) {

      const menu = new Mmenu( "#menu-mobile", {
        // options
        "slidingSubmenus": false,
        "theme": "white",
        "navbar": {
          "add": false
        },
        "navbars": [
          {
            "position": "top",
            "content": [
              document.getElementById('usa-mobile-toolbar'),
              'close'
            ]
          },
          {
            "position": "bottom",
            "content": [
              document.getElementById('cta-risk-mobile')
            ]
          }
        ],
        offCanvas: {
          // off-canvas options
          "position": "right-front"
        }
      }, {
        // configuration
        classNames: {
          selected: "menu-item--active-trail"
        },
        offCanvas: {
          // off-canvas configuration
          menu: {
            insertSelector: ".mm-menu-mobile"
          },
          page: {
            selector: ".dialog-off-canvas-main-canvas"
          }
        }
      });

    }
  }

  return {
    init
  }
}()

export default MenuUsa
